import React from 'react';
import Menu from '../components/Menu';
import { useSelector, useDispatch } from 'react-redux';
import { setOrgId, setApiKey, login, reducerName } from '../store/AuthStore';
import { useNavigate } from 'react-router-dom';

const Login = () => {
    const authState = useSelector(state => state[reducerName]);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const handleLogin = (e) => {
        e.preventDefault();
        dispatch(login());
        navigate('/');
    };

    const handleOrgIdChange = (e) => {
        dispatch(setOrgId(e.target.value));
    };

    const handleApiKeyChange = (e) => {
        dispatch(setApiKey(e.target.value));
    };

    return (
        <div className="App">
            <Menu />
            <div className='login'>
                <form onSubmit={handleLogin}>
                    <label>OrganizationId</label>
                    <input type='text' placeholder='Id' value={authState.orgId} onChange={handleOrgIdChange} />
                    <label>ApiKey</label>
                    <input type='password' placeholder='Api-key' value={authState.apiKey} onChange={handleApiKeyChange} />
                    <input type='submit' className='btn' value='login' />
                </form>
            </div>
        </div>
    );
};

export default Login;